// Handle CTA buttons - either navigate to app subdomain or open contact form
export const handleCTA = (
  // e: React.MouseEvent<HTMLButtonElement>,
  action: string
) => {
  // e.preventDefault();
  if (action === "signup" || action === "login") {
    window.location.href = `https://app.weqiq.com/${action}`;
  } else if (action === "demo") {
    window.location.href = "https://app.weqiq.com/signup";
  }
};
